import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { mangaList } from "@/mocks/manga";
import { sortByPopularity } from "@/utils/manga";

export default function Footer() {
  const hot = sortByPopularity(mangaList).slice(0, 6);
  return (
    <footer className="border-t border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* brand */}
          <div>
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
                <i className="ri-book-open-line" />
              </span>
              <span className="font-heading text-xl text-foreground-950">
                歪歪<span className="text-primary-600">漫画</span>网
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              歪歪漫画网分类大全覆盖恋爱、热血、悬疑、治愈等全题材，人气排行与热门榜单实时更新，新作推荐、完结作品、免费专区一站直达，助你快速找到想看的漫画。
            </p>
            <div className="mt-4 flex gap-2">
              {["ri-wechat-line", "ri-weibo-line", "ri-bilibili-line", "ri-mail-line"].map((i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="社交媒体链接"
                  onClick={(e) => e.preventDefault()}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200/80 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  <i className={`${i} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          {/* 分类 */}
          <nav aria-label="分类导航">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-foreground-900">漫画分类</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-2 gap-y-2.5">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link
                    to={`/category/${c.id}`}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* 快速导航 */}
          <nav aria-label="快捷导航">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-foreground-900">快捷导航</h3>
            <ul className="mt-4 space-y-2.5">
              {[
                { label: "人气排行榜", to: "/rankings" },
                { label: "新作推荐", to: "/new" },
                { label: "完结作品", to: "/completed" },
                { label: "免费专区", to: "/free" },
                { label: "关于我们", to: "/about" },
                { label: "常见问题", to: "/faq" },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* 热门 */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-foreground-900">热门推荐</h3>
            <ul className="mt-4 space-y-2.5">
              {hot.map((m) => (
                <li key={m.id}>
                  <Link to={`/manga/${m.id}`} className="group flex items-center gap-2 text-sm">
                    <span className="truncate text-foreground-600 transition-colors group-hover:text-primary-600">
                      {m.title}
                    </span>
                    <span className="ml-auto shrink-0 text-xs text-primary-500">{m.rating}分</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-200/70 pt-6 text-center sm:flex-row sm:items-center sm:justify-between sm:text-left">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 歪歪漫画网 waiwaimanga.com 版权所有 · 漫画分类大全 · 人气排行 · 免费漫画阅读推荐
          </p>
          <p className="text-xs text-foreground-500">联系邮箱：contact@waiwaimanga.com</p>
        </div>
      </div>
    </footer>
  );
}